import { Page } from "./router-enum"
const constantRoutes = [
  {
    path: Page.LOGIN,
    name: Page.LOGIN,
    component: () => import("views/Login/index.vue"),
  },
  {
    path: Page.EASY_LOGIN,
    name: Page.EASY_LOGIN,
    component: () => import("views/Login/index.vue"),
  },
  {
    path: Page.AGREEMENT,
    name: Page.AGREEMENT,
    component: () => import("components/Agreement/PrivacyPolicyAgreement.vue"),
  },
  {
    path: Page.EASY_REGISTER,
    name: Page.EASY_REGISTER,
    component: () => import("views/Register/EasyMode/index.vue"),
  },
  {
    path: Page.SUPPORT_LOGIN,
    name: Page.SUPPORT_LOGIN,
    component: () => import("views/Support/Login/index.vue"),
  },
  {
    path: Page.LOGOUT,
    name: Page.LOGOUT,
    component: () => import("views/Login/Logout.vue"),
  },
  // {
  //   path: Page.REFRESH_LOGIN,
  //   name: Page.REFRESH_LOGIN,
  //   component: () => import("views/Login/RefreshLogin.vue"),
  // },
  // {
  //   path: Page.WX_AUTO_LOGIN,
  //   name: Page.WX_AUTO_LOGIN,
  //   component: () => import("views/Login/WxAutoLogin.vue"),
  // },

  {
    path: Page.REGISTER,
    name: Page.REGISTER,
    component: () => import("views/Register/NormalMode/index.vue"),
  },

  {
    path: Page.SUPPORT_REGISTER,
    name: Page.SUPPORT_REGISTER,
    meta: { keepAlive: true },
    component: () => import("views/Support/Register/index.vue"),
  },
  // {
  //   path: Page.REGISTER_STAFF,
  //   name: Page.REGISTER_STAFF,
  //   meta: { keepAlive: true },
  //   component: () => import("views/Register/RegisterStaff.vue"),
  // },
  {
    path: Page.RETRIEVE_PASSWORD,
    name: Page.RETRIEVE_PASSWORD,
    component: () => import("views/RetrievePassword/index.vue"),
  },
  {
    path: Page.SUPPORT_RETRIEVE_PASSWORD,
    name: Page.SUPPORT_RETRIEVE_PASSWORD,
    component: () => import("views/Support/RetrievePassword/index.vue"),
  },
  // {
  //   path: Page.AGREEMENT,
  //   component: () => import("views/Agreement/Agreement.vue"),
  // },
  {
    path: Page.REGISTER_SUCCESS,
    component: () => import("views/RegisterFinish/RegisterFinishPage.vue"),
  },
  // {
  //   path: Page.SUPPORT_REGISTER_SUCCESS,
  //   component: () => import("views/Support/Register/RegisterFinishPage.vue"),
  // },
  // {
  //   path: Page.ACCOUNT_CENTER_NAV,
  //   component: () => import("views/AccountCenterNav/AccountCenterNavPage.vue"),
  // },
  {
    path: Page.PRODUCT_MAP,
    component: () => import("views/AccountCenter/ProductMap/ProductMapPage.vue"),
  },
  // {
  //   path: Page.ACCOUNT_CENTER_ERROR_PAGE,
  //   component: () =>
  //     import("views/AccountCenterError/AccountCenterErrorPage.vue"),
  // },
  {
    path: Page.AUTH_CODE_LOGIN,
    component: () => import("views/AuthCode/login.vue"),
  },
	{
		path: Page.AUTH_CODE_TOKEN,
		component: () => import('views/AuthCode/index.vue'),
	},
    {
		path: "/test",
		component: () => import('views/Test.vue'),
	},
]

export default constantRoutes
